import { InfoCircleOutlined } from '@ant-design/icons';
import { Disclosure, Transition } from '@headlessui/react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const Collapse = ({ title, icon, children, error, defaultOpen = false }) => {
    return (
        <Disclosure defaultOpen={defaultOpen}>
            {({ open }) => (
                <>
                    <Disclosure.Button
                        disabled={open && error}
                        className={classNames(
                            'flex w-full justify-between items-center rounded-lg bg-white px-4 py-2 text-left text-sm font-medium cursor-pointer border-none h-[50px]',
                            {
                                'bg-[#FFF8F9] text-[#95A0A8]': error,
                                'text-[#95A0A8]': !error && !open,
                            }
                        )}
                    >
                        <div className="flex items-center space-x-2 font-semibold text-base text-purple">
                            {icon}
                            <span className="flex items-center space-x-2">
                                <span
                                    className={classNames({
                                        'text-[#F0536F]': error,
                                    })}
                                >
                                    {title}
                                </span>
                                {error && (
                                    <InfoCircleOutlined className="text-[#F0536F]" />
                                )}
                            </span>
                        </div>
                        <svg
                            className={`${open ? 'rotate-180 transform' : ''}`}
                            width="8"
                            height="5"
                            viewBox="0 0 8 5"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M4.55996 4.79932C4.17087 5.0633 3.63699 5.02291 3.29222 4.67814L0.463792 1.84971C0.0732674 1.45919 0.0732674 0.826023 0.463792 0.435498C0.854316 0.044974 1.48748 0.044974 1.87801 0.435498L3.99933 2.55682L6.12068 0.435471C6.5112 0.0449471 7.14437 0.044947 7.53489 0.435471C7.92542 0.825996 7.92542 1.45916 7.53489 1.84968L4.70646 4.67811C4.70158 4.683 4.69665 4.68783 4.69169 4.69259C4.65018 4.73245 4.60609 4.76802 4.55996 4.79932Z"
                                fill="#65707A"
                            />
                        </svg>
                    </Disclosure.Button>
                    <Transition
                        show={open}
                        enter="transition duration-100 ease-out"
                        enterFrom="transform scale-95 opacity-0"
                        enterTo="transform scale-100 opacity-100"
                        leave="transition duration-75 ease-out"
                        leaveFrom="transform scale-100 opacity-100"
                        leaveTo="transform scale-95 opacity-0"
                    >
                        <Disclosure.Panel className="max-h-60vh overflow-auto px-4 py-2 relative bg-white -mt-2 rounded-b-lg">
                            {children}
                        </Disclosure.Panel>
                    </Transition>
                </>
            )}
        </Disclosure>
    );
};
Collapse.propTypes = {
    title: PropTypes.string.isRequired,
    icon: PropTypes.element,
    children: PropTypes.node,
    error: PropTypes.bool,
    defaultOpen: PropTypes.bool,
};

export default Collapse;
